import React from 'react'

import CustomAvatar from './Avatar'
import CardAvatar from './CardAvatar'

import { isUUID } from '../../../utilities'

const MediaAvatar = ({
  user,
  onMouseEnter = undefined,
  onMouseLeave = undefined,
  hideCard = false,
  rootClass = undefined,
  ...props
}) => {
  const showCard = React.useMemo(() => {
    if (user && typeof user === 'object' && isUUID(user.id)) {
      return true
    }

    return false
  }, [user])

  if (hideCard || !showCard) {
    return (
      <div>
        <CustomAvatar user={user} {...props} />
      </div>
    )
  }

  return (
    <CardAvatar
      user={user}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      rootClass={rootClass}
      {...props}
    />
  )
}

export default React.memo(MediaAvatar)
